import { createContext, useContext, type PropsWithChildren } from "react";
import { ApolloProvider, type ApolloClient } from "@apollo/client";
import type { ShellHandleHost } from "./createShellHandle";

const ShellHostContext = createContext<ShellHandleHost | null>(null);

export interface ShellHostProviderProps {
  host: ShellHandleHost;
  client: ApolloClient<unknown>;
}

export function ShellHostProvider({
  host,
  client,
  children,
}: PropsWithChildren<ShellHostProviderProps>) {
  return (
    <ApolloProvider client={client}>
      <ShellHostContext.Provider value={host}>
        {children}
      </ShellHostContext.Provider>
    </ApolloProvider>
  );
}

export function useShellHost(): ShellHandleHost {
  const v = useContext(ShellHostContext);
  if (!v)
    throw new Error("useShellHost must be used within <ShellHostProvider>");
  return v;
}
